<template>
    <!-- contents -->
    <div id="contents">
        <div class="contents_wrap">
            <!-- contents_head -->
            <!-- breadcrumbs -->
            <fragment>
                <skp-breadcrumbs @page-title="val => (pageTitle = val)" />
            </fragment>
            <!-- //breadcrumbs -->
            <h2 class="pg_title">
                {{ pageTitle }}
                <em class="ico_info">
                    <i class="tooltip fl_btm">{{ $t('MESSAGE.DATA.INACTIVE.ANSWER') }}</i>
                </em>
            </h2>
            <!-- //contents_head -->

            <!-- srchTop_wrap -->
            <div class="srchTop_wrap srchQna_wrap pb20">
                <article class="srch_basic">
                    <dl class="dl_search">
                        <dd data-input-type="select">
                            <select class="slt_white w100" v-model="searchType">
                                <option value="">{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                <option v-for="item in searchTypeList" :key="pageName + item.code" :value="item.code">
                                    {{ item.codeName }}
                                </option>
                            </select>
                        </dd>
                        <dd class="clearable" data-input-type="input">
                            <input
                                type="text"
                                class="text_input w100p"
                                placeholder="Enter a user ID or user name"
                                v-model="searchName"
                                @keyup.enter.stop="onSearch(1)"
                                v-clearable
                            />
                        </dd>
                        <dd class="btn">
                            <a href="javascript:" class="btn_srch" @click="onSearch(1)">
                                {{ $t('BUTTON.GLOBAL.SEARCH') }}
                            </a>
                        </dd>
                    </dl>
                </article>
            </div>
            <!-- Grid -->
            <div class="grid_wrap">
                <!-- Count -->
                <div class="grid_total">
                    {{ $t('TITLE.TOTAL.COUNT') }} <em>{{ totalCount }}</em>
                </div>
                <div class="btn_wrap">
                    <a href="javascript:" class="btn_gray" @click="pageMove()">{{ $t('BUTTON.GOTO.ASNWER.MANAGE') }}</a>
                </div>
                <!-- Grid -->
                <toast-grid
                    :gridId="gridId"
                    :columns="columns"
                    :data="gridData"
                    :options="options"
                    :ref="gridId"
                    :key="gridKey"
                    :isTotalCount="false"
                    :click="contentClick"
                />
                <div class="paginate">
                    <sdl-pagination
                        align="center"
                        :current-page="currentPage"
                        :total-rows="totalCount"
                        :per-page="nRecordsPerPage"
                        @change="onSearch"
                    />
                </div>
            </div>
        </div>
    </div>
    <!-- contents -->
</template>

<script>
import $ from 'jquery';
import qs from 'query-string';
import Vue from 'vue';
import api from '@/service';
import axios from 'axios';
import store from '@/vuex/store';
import moment from 'moment';
import SDLUtil from '@/utils/SDLUtil';
import { mapActions, mapGetters } from 'vuex';

import ToastGrid from '~c/ToastGrid';
import SDLPagination from '~~c/control/pagination/Pagination';
import SKPBreadcrumbs from '~vb/main/SKPBreadcrumbs';
import DatePicker from '~c/DatePicker';

import inactiveAnswererPop from '~va/qnaManager/popup/inactiveAnswererPop';

require('moment-jdateformatparser');

export default {
    name: 'inactiveAnswererList',
    components: {
        'skp-breadcrumbs': SKPBreadcrumbs,
        'toast-grid': ToastGrid,
        'sdl-pagination': SDLPagination,
    },
    data() {
        return {
            pageName: 'inactiveAnswererList',
            pageTitle: '',
            searchType: 'S',
            searchTypeList: [],
            searchName: '',
            totalCount: 0,
            currentPage: 1,
            nRecordsPerPage: Number(localStorage.getItem('listRows')),
            gridKey: 0,
            gridId: 'inactiveAnswererListGrid',
            columns: [
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.SUBSIDIARY'),
                    name: 'DEPT_NM',
                    align: 'center',
                    // width: 125,
                    resizable: true,
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.USER.ID'),
                    name: 'LOGIN_ID',
                    align: 'center',
                    // width: 75,
                    resizable: true,
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.USER.NAME'),
                    name: 'LOGIN_NAME',
                    align: 'center',
                    // width: 75,
                    resizable: true,
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.LOGGED.IN'),
                    name: 'RECENT_DT',
                    align: 'center',
                    // width: 375,
                    resizable: true,
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.STATUS'),
                    name: 'STATUS_NM',
                    align: 'center',
                    // width: 175,
                    resizable: true,
                    sortable: false,
                },
            ],
            gridData: [],
            options: {
                scrollY: true,
                scrollX: true,
                minBodyHeight: 80,
                bodyHeight: 450,
            },
        };
    },
    mounted() {
        this.getCommonCodeList();
        this.onSearch(1);
    },
    computed: {
        ...mapGetters({
            corpCd: 'getCorpCd',
            deptLevelCd: 'getDeptLevelCd',
            curLoginNo: 'getLoginNo',
            roles: 'getRoles',
            menus: 'getMenus',
        }),
    },
    methods: {
        async onSearch(v) {
            SDLUtil.showLoadingBar(true);
            return await axios
                .post(
                    `${SDLUtil.API_URL}/skp/basis/admin/qnaManager/inactiveAnswerer/inactiveAnswerer.skp`,
                    qs.stringify({
                        page: v,
                        viewMode: 'Main',
                        searchType: this.searchType,
                        searchName: this.searchName,
                        searchCorpCd: this.corpCd,
                    }),
                )
                .then(resp => {
                    this.gridData = resp.data.result.rowData;
                    for (const iterator of this.gridData) {
                        if ('Sleep' === iterator.STATUS_NM) {
                            iterator.STATUS_NM = '<em class="txt_Inactive">' + iterator.STATUS_NM + '</em>';
                        }
                    }
                    this.totalCount = resp.data.search.totalRecords;
                    this.currentPage = Number(resp.data.search.page);
                    this.gridKey++;
                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        pageMove() {
            return this.$router.push(
                this.menuCommit(
                    'Admin',
                    'Answerer Manage',
                    '/skp/basis/admin/qnaManager/answererManage/answererManageList',
                ),
            );
        },
        menuCommit(menu, subMenu, connUrl) {
            for (const menus of this.menus) {
                if (menu === menus.menuNm) {
                    for (const menu of menus.subMenu) {
                        if (subMenu === menu.menuNm) {
                            store.commit('PARAMS', { menuId: menu.menuId, creationYn: menu.creationYn });
                            if (SDLUtil.isNull(connUrl)) {
                                connUrl = menu.connUrl.replace('.skp', '');
                            }
                            return connUrl;
                        }
                    }
                }
            }
            if ('Admin' === menu) {
                return connUrl;
            }
        },
        async getCommonCodeList() {
            this.searchTypeList = await api.getCommonCodeList('LOGIN_STATUS');
        },
        contentClick(e, rowData, grid) {
            this.inactiveAnswererPop(
                rowData[e.rowKey]['CHRG_USER_NO'],
                rowData[e.rowKey]['DEPT_NO'],
                rowData[e.rowKey]['DEPT_NM'],
                rowData[e.rowKey]['LOGIN_NAME'],
            );
        },
        inactiveAnswererPop(v1, v2, v3, v4) {
            SDLUtil.show(
                inactiveAnswererPop,
                {
                    searchChrgUserNo: v1,
                    searchCorpCd: v2,
                    searchDeptNm: v3,
                    searchLoginName: v4,
                },
                {
                    width: '500px',
                    height: 'auto',
                },
            );
        },
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/skpComponents/view/admin/qnaManager/inactiveAnswererList.vue